import API from '../..';
const ENTITY = 'panel-modules';

export const patchItem = (uuid, data) =>
    API.patch(`/api/v1/${ENTITY}/${uuid}/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
